import { LoginService } from './../login.service';
import { SettingsService } from '../settings.service';
import { Component, Input, OnChanges, SimpleChanges ,OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-rooms-activity-hours',
    templateUrl: './rooms-activity-hours.component.html',
    styleUrls: ['./rooms-activity-hours.component.scss'],
    standalone: false
})
export class RoomsActivityHoursComponent implements OnInit {
  @Input() selectedRoomId: number | null = null;
  activityHours = {
    sunday: [],
    monday: [],
    tuesday:[],
    wednesday:[],
    thursday:[],
    friday:[],
    saturday:[],
  };
  saved=false
  exams=[]
  addRoom=false
  showDeleteAlert=false
  editRoom=false
  hasUnsavedChanges: boolean = false;
  selectedRoom: any = null;
  dateRangeError: string = '';
  readonly weekDays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  constructor(public settings:SettingsService,public ls:LoginService,private translate: TranslateService) { }

  // The room currently being configured (the one selected in the toolbar)
  get currentRoom(): any {
    return this.ls.rooms.find(room => room.AutoIndex == this.ls.room);
  }

  // All unique weekday names covered by the one-time room's date range
  get oneTimeDayNames(): string[] {
    const room = this.currentRoom;
    if (!room || !room.isOneTime || !room.oneTimeDate) return [];
    const from = new Date(room.oneTimeDate); from.setHours(12, 0, 0, 0);
    const to = room.oneTimeDateTo ? new Date(room.oneTimeDateTo) : new Date(from);
    to.setHours(12, 0, 0, 0);
    const days: string[] = [];
    const cur = new Date(from);
    while (cur <= to) {
      const name = this.weekDays[cur.getDay()];
      if (!days.includes(name)) days.push(name);
      cur.setDate(cur.getDate() + 1);
    }
    return days;
  }

  // For a one-time room show only the days in its range; otherwise the full week
  get daysToShow(): string[] {
    const days = this.oneTimeDayNames;
    return days.length ? days : this.weekDays;
  }

  ngOnInit(): void {
    this.settings.getExams().then((data)=>{
     this.exams= data
     
     
    });
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedRoomId) {
      this.fetchActivityHours();
    }
  }


  
  fetchActivityHours(): void {
    this.settings.getActivityHours(false,true).subscribe({
      next: (data) => this.activityHours = data,
      error: (err) => console.error('Failed to fetch activity hours', err)
    });
  }

  getRoomName(roomId){
    let room=this.ls.rooms.find(room=>room.AutoIndex==roomId)
    this.selectedRoom={...room}
  }

  private validateOneTimeRange(room: any): string {
    if (!room.isOneTime) return '';
    if (!room.oneTimeDate || !room.oneTimeDateTo) return 'יש למלא תאריך התחלה וסיום';
    const from = new Date(room.oneTimeDate);
    const to = new Date(room.oneTimeDateTo);
    const diffDays = (to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24);
    if (diffDays < 0) return 'תאריך הסיום חייב להיות גדול או שווה לתאריך ההתחלה';
    if (diffDays > 6) return 'טווח החדר הזמני לא יכול לעלות על שבוע';
    return '';
  }

  updateRoomName(){
    this.dateRangeError = this.validateOneTimeRange(this.selectedRoom);
    if (this.dateRangeError) return;
    this.settings.updateRoomName(this.selectedRoom).subscribe({
      next: (data) => {
        this.editRoom=false;
        this.dateRangeError = '';
        this.ls.rooms=data['rooms'];
      },
      error: (err) => console.error('Failed to update room name', err)
    });
  }
  saveActivityHours(): void {
    this.settings.saveActivityHours(this.activityHours,true).subscribe({
      next: (response) => {
        this.saved=true;
        this.hasUnsavedChanges = false;
      this.fetchActivityHours()},
      error: (err) => console.error('Failed to save activity hours', err)
    });
  }

   getUserTimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  addHour(day: string): void {
    if (!this.activityHours[day]) {
      this.activityHours[day] = [];
    }
    const userTimeZone = this.getUserTimeZone(); // Method that returns a string like "Europe/London"
    const room = this.currentRoom;
    // Pre-fill the exam type chosen at creation for one-time rooms
    const defaultExamType = (room && room.isOneTime && room.oneTimeExamType) ? room.oneTimeExamType : '';
    this.activityHours[day].push({
      startTime: '',
      endTime: '',
      status: 'new',
      dayOfTheWeek: day,
      timeZone: userTimeZone,
      examType: defaultExamType,
      includeInRoomSearch: true,
      hasTempActivity: false, // initially false
      temp: null // temp will be added only if hasTempActivity is true
    });
    }

  deleteHour(day, index){
    if (this.activityHours[day] && this.activityHours[day][index]) {
      if (this.activityHours[day][index].AutoIndex) {
        this.hasUnsavedChanges = true;
        this.activityHours[day][index].status = 'delete';
      }
      else {
        this.activityHours[day].splice(index, 1);
      }
    }
    
  }
  

  markAsUpdated(day: string, index: number): void {
    this.hasUnsavedChanges = true;
    if (this.activityHours[day] && this.activityHours[day][index]) {
      const hour = this.activityHours[day][index];
  
      if (hour.hasTempActivity && !hour.temp) {
        hour.temp = {
          examType: '',
          startTime: '',
          endTime: ''
        };
      }
  
      if (hour.status !== 'new') {
        hour.status = 'update';
      }
    }
  }
  
  getExamName(exam): string {
   
    return exam.custom ? exam.examType : exam.examName;
  }

  

  getExamTypes(){
   return this.exams
  }

  getOneTimeExamName(): string {
    const room = this.currentRoom;
    if (!room?.oneTimeExamType) return '';
    const exam = this.exams.find(e => e.AutoIndex == room.oneTimeExamType);
    return exam ? this.getExamName(exam) : '';
  }

  deleteRoom(roomId){
  this.settings.deleteRoom(roomId).subscribe({
    next: (data) =>{
       this.ls.rooms=data['rooms'];
       this.ls.room=data['rooms'] && data['rooms'].length? data['rooms'][0]['AutoIndex']:null
       this.showDeleteAlert=false
  },
    error: (err) => console.error('Failed to delete Room ', err,'room id',roomId)
  });
  }


  // Returns the specific calendar date within the one-time room range that falls on the given weekday name
  getDateForDay(dayName: string): string {
    const room = this.currentRoom;
    if (!room || !room.isOneTime || !room.oneTimeDate) return '';
    const cur = new Date(room.oneTimeDate); cur.setHours(12, 0, 0, 0);
    const to = room.oneTimeDateTo ? new Date(room.oneTimeDateTo) : new Date(cur);
    to.setHours(12, 0, 0, 0);
    while (cur <= to) {
      if (this.weekDays[cur.getDay()] === dayName) return this.formatDate(cur);
      cur.setDate(cur.getDate() + 1);
    }
    return '';
  }

  formatDate(dateVal: any): string {
    if (!dateVal) return '';
    const d = new Date(dateVal);
    d.setHours(12, 0, 0, 0);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    return `${day}/${month}/${d.getFullYear()}`;
  }

  formatDateForInput(dateVal: any): string {
    if (!dateVal) return '';
    const d = new Date(dateVal);
    d.setHours(12, 0, 0, 0);
    return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
  }
  
  // Updates temp dates based on user input
  updateTempDate(day: string, index: number, field: string, event: any): void {
    this.hasUnsavedChanges = true;
    const newValue = event.target.value;
    if (this.activityHours[day][index].temp) {
      this.activityHours[day][index].temp[field] = newValue;
      this.markAsUpdated(day, index); // Ensure to mark the change as updated
    }
  }
}
